import { Form, Input, Select } from "@/atoms"
import { getOperatorOptions, isCustomProperty } from "@/helpers/scope.helper"
import { RemoveButton } from "@/organisms/Form/components/RemoveButton"

import styles from "./ResourcesList.module.scss"

import type { FieldsProps } from "."

export const Fields = (props: FieldsProps) => {
  const { name, path, form, componentProps } = props
  const values = form.getFieldValue(path)
  const { resource, property: propertyName } = values || {}
  const property = { resourceName: resource, propertyName }
  const conditionsNumber = form.getFieldValue(path[0])
  const filtersNumber = form.getFieldValue(path.slice(0, -1))
  const onlyOneCardAndRecord =
    conditionsNumber.length === 1 && filtersNumber.length === 1

  const { disabled, options, t } = componentProps
  const rules = [{ required: true, message: t("error.requiredField") }]
  const FIELD_NAMES = {
    resource: "resource",
    property: "property",
    operator: "operator",
    exactKey: "exactKey",
    value: "value"
  }

  return (
    <div className={styles.fields}>
      <Form.Item
        name={[name, FIELD_NAMES.resource]}
        className={styles.formItem}
        rules={rules}
        data-testid={FIELD_NAMES.resource}
      >
        <Select
          placeholder={t(`general.${FIELD_NAMES.resource}`)}
          options={options.resources}
          disabled={disabled}
          onChange={() =>
            form.setFields([
              { name: [...path, FIELD_NAMES.property], value: undefined },
              { name: [...path, FIELD_NAMES.operator], value: undefined }
            ])
          }
        />
      </Form.Item>
      <Form.Item
        shouldUpdate
        name={[name, FIELD_NAMES.property]}
        className={styles.propertyFormItem}
        rules={rules}
        data-testid={FIELD_NAMES.property}
      >
        <Select
          placeholder={t(`general.${FIELD_NAMES.property}`)}
          options={options.fields[resource]}
          disabled={disabled}
          // The property column shrinks with the form; list long properties
          // (e.g. "GitHub Custom Property") in full rather than ellipsized
          popupMatchSelectWidth={false}
          onChange={() =>
            form.setFieldValue([...path, FIELD_NAMES.operator], undefined)
          }
        />
      </Form.Item>
      {isCustomProperty(property) && (
        <Form.Item
          name={[name, FIELD_NAMES.exactKey]}
          className={styles.value}
          rules={rules}
          data-testid={FIELD_NAMES.exactKey}
        >
          <Input
            placeholder={t(`general.${FIELD_NAMES.exactKey}`)}
            disabled={disabled}
          />
        </Form.Item>
      )}
      <Form.Item
        name={[name, FIELD_NAMES.operator]}
        className={styles.operator}
        rules={rules}
        data-testid={FIELD_NAMES.operator}
      >
        <Select
          placeholder={t(`general.${FIELD_NAMES.operator}`)}
          disabled={disabled}
          options={getOperatorOptions(t, property)}
          popupMatchSelectWidth={false}
        />
      </Form.Item>
      <Form.Item
        name={[name, FIELD_NAMES.value]}
        className={styles.value}
        rules={rules}
        data-testid={FIELD_NAMES.value}
      >
        <Input placeholder={t("general.value")} disabled={disabled} />
      </Form.Item>
      <RemoveButton
        name={name}
        disabled={onlyOneCardAndRecord || disabled}
        onClick={() => {
          if (onlyOneCardAndRecord) return

          if (filtersNumber.length === 1) return props.removeCard()

          props.remove(props.index)
        }}
      />
    </div>
  )
}
